<template>
  <div>
    <mu-paper class="nav bottom" v-if="!isHcpView">
      <div class="content">
        <ul style="white-space: nowrap;padding: 0;" class="horizontalScroll">
          <li
            v-for="item, index in filterTypes"
            :key="'filter-' + index"
            v-bind:class="{isActive: item.type === query.type}"
            @click="setFilter(item)"
          >
            {{item.title}}
            <span v-if="item.type === 'MY_ANSWERS'" style="margin-left: 8px; color:white">
            <mu-badge primary :content="userAnswers"/>
            </span>
            <span v-if="item.type === 'MY_QUESTIONS'" style="margin-left: 8px; color:white">
             <mu-badge primary :content="userQuestions"/>
            </span>
          </li>
          <li v-bind:class="{isActive: item.id === query.category}" v-for="item, index in categories" @click="setCategory(item)" :index="'category-' + item.id"
              v-if="item.count > 0">
            {{item.name}}
            <span style="margin-left: 8px; color:white">
             <mu-badge primary :content="item.count"/>
            </span>
          </li>
        </ul>
      </div>
    </mu-paper>
    <mu-row gutter class="content">
      <mu-col desktop="70" tablet="60" width="100" class="bottom">
        <mu-card v-if="query.type === 'SEARCH'">
          <mu-card-text>
            <div>Search term: <strong>{{query.q}}</strong></div>
            <div v-if="!isLoading">
              <span v-if="data.total_questions > query.per_page"> Showing <strong v-text="query.per_page"></strong> of </span>
              <strong v-text="data.total_questions"></strong> results
            </div>
          </mu-card-text>
        </mu-card>
        <mu-card>
          <div>
            <mu-list>
              <div v-if="isLoading">
                <mu-list-item
                  class="noCursor"
                  v-for="item, index in dummyLoaders"
                  :key="'dummy-loader-' + index"
                  :title="item.display_name"
                >
                  <mu-linear-progress
                    slot="describe" color="#d9d9d9"
                    style="width: 50%; height: 14px;background: rgb(214, 214, 214); margin-bottom: 8px"
                    v-bind:style="{width: getRandomArbitrary(40, 50)}"
                  ></mu-linear-progress>
                  <mu-avatar
                    v-once
                    :src="item.image"
                    slot="left"
                    color="white"
                    backgroundColor="#E9E9E8"
                  >
                  </mu-avatar>
                  <div slot="describe">
                    <mu-linear-progress
                      color="#d9d9d9"
                      style="height:12px; width: 15%; background: #f1f1f1"
                    ></mu-linear-progress>
                  </div>
                </mu-list-item>
              </div>
              <mu-list-item
                v-if="!isLoading"
                class="questionItem"
                v-for="question, index in data.questions"
                v-bind:class="{isHidden: isAuthAdmin && question.hidden}"
                :key="'question-' + index"
                disableRipple
              >
                <mu-avatar
                  v-if="!question.profile_large"
                  slot="left"
                  color="#0179d5"
                  backgroundColor="#E9E9E8">
                  {{upperTwoInitials(question.display_name ? question.display_name : question.firstname + ' ' + question.surname)}}
                </mu-avatar>
                <mu-avatar
                  v-else
                  :src="question.profile_large"
                  slot="left"
                  color="white"
                  backgroundColor="#E9E9E8"
                  @click="goToProfile(question.url)"
                >
                </mu-avatar>
                <div slot="title">
                  <router-link class="linkSize" :to="{}" @click.native="goToQuestion(question.question_id)">
                    <div v-if="question.question.length < 200" v-html="$sanitize(upperCaseFirst(question.question))"></div>
                    <div v-if="question.question.length > 200" v-html="`$sanitize(${question.question.substr(0, 200)}...)`"></div>
                  </router-link>
                </div>
                <div slot="describe">
                  <div class="asked-by">
                    <span v-text="$t('message.discussionAskedBySuffix')"></span>
                    <router-link :to="'/profile/' + question.url"><span v-text="question.display_name"></span></router-link>
                    {{$t('message.discussionAskedAtSuffix')}}<span class="date">{{formatDate(question.timestamp)}}</span>
                  </div>
                  <div class="actions">
                    <span class="label-container" v-if="question.replies > 0">
                      <mu-icon color="#0179d5" value="reply" :size="24"></mu-icon>
                      <span class="inline-label"
                            v-html="$sanitize(question.replies + (question.replies > 1 ? ` ${$t('message.repliesText')}` : ` ${$t('message.replyText')}`))"></span>
                    </span>
                    <span v-if="question.likes > 0" class="label-container">
                      <mu-icon color="red" :size="24"
                               :value="question.liked ? 'favorite' : 'favorite_border'"></mu-icon>
                      <span class="inline-label"
                            v-html="question.likes +  (question.likes > 1 ? ` ${$t('message.likesText')}`: ` ${$t('message.likeText')}`)"></span>
                    </span>
                    <span v-if="isAuthAdmin && question.report_count > 0" class="label-container">
                      <mu-icon :size="24" color="#E74C3C" value="report_problem"></mu-icon>
                      <span class="inline-label" v-html="question.report_count"></span>
                    </span>
                    <span v-if="isAuthAdmin && question.hidden">
                      <mu-icon value="visibility_off" :size="24"></mu-icon>
                    </span>
                    <span v-if="isAuthAdmin && question.hcp == 1">
                      <mu-icon value="local_hospital" color="#8bc34a" :size="24"></mu-icon>
                      <span class="inline-label">HCP Question</span>
                    </span>
                  </div>
                </div>
                <mu-icon-menu
                  :anchorOrigin="rightTop"
                  :targetOrigin="rightTop"
                  :scroller="scroller"
                  slot="right"
                  icon="more_vert"
                  desktop
                  v-if="(!question.is_admin || isAuthAdmin) && $store.state.status.payment.paid"
                >
                  <mu-menu-item
                    leftIcon="report"
                    :title="question.reported ? 'Reported' : 'Report'"
                    @click="openReport('THREAD_QUESTION', question.question_id)"
                    :disabled="question.reported"
                    v-if="!question.is_admin && !isAuthAdmin"
                  />
                  <mu-menu-item
                    @click.native="hideQuestion(question, index)"
                    :leftIcon="question.hidden === false ? 'visibility_off' : 'visibility'"
                    v-if="isAuthAdmin"
                    :title="question.hidden ===  false ? $t('message.hideText') : $t('message.restoreText')"
                  />
                  <mu-menu-item
                    @click.native="deleteQuestion(question, index)"
                    leftIcon="delete"
                    v-if="isAuthAdmin"
                    :title="$t('message.deleteText')">
                  </mu-menu-item>
                </mu-icon-menu>
              </mu-list-item>
            </mu-list>
            <mu-card-text v-show="!isLoading"
                          v-if="query.per_page < data.total_questions || data.total_questions === 0">
              <div class="errorMessage" v-if="data.total_questions === 0">
                <p v-text="displayMessage"></p>
              </div>
              <div class="pagination" v-if="query.per_page < data.total_questions">
                <a @click="handlePageChange(1)" class="mu-pagination-item firstItem">First</a>
                <mu-pagination
                  :total="data.total_questions"
                  :current="data.page"
                  :defaultPageSize="5"
                  :pageSize="query.per_page"
                  @pageChange="handlePageChange">
                </mu-pagination>
                <a @click="handlePageChange(data.total_questions)" class="mu-pagination-item lastItem">Last</a>
              </div>
            </mu-card-text>
          </div>
        </mu-card>
      </mu-col>
      <mu-col desktop="30" tablet="40" width="100">
        <div class="bottom">
          <mu-flat-button
            class="askButton"
            backgroundColor="#3d8517"
            color="white"
            @click.native="askQuestion"
            :label="isHcpView ? 'New Topic' : $t('message.discussionButtonAsk')"
          >
          </mu-flat-button>
        </div>
        <search-questions :isSearching="isSearching" class="bottom"></search-questions>
        <!--<my-questions v-if="$store.state.user.scope" :userId="$store.state.user.scope.user_id" class="bottom"></my-questions>-->
        <top-contributors v-if="!isHcpView" class="bottom"></top-contributors>
        <frequently-asked v-if="!isHcpView" class="bottom"></frequently-asked>
      </mu-col>
      <report-modal
        v-if="activeReport.type && activeReport.type_id"
        :open="activeReport.open"
        :type="activeReport.type"
        :type_id="activeReport.type_id"
        @onClose="activeReport.open = false"
        @onComplete="setReported(activeReport)">
      </report-modal>
    </mu-row>
  </div>
</template>
<script>

  import DiscussionApi from '../../api/Discussion'
  import config from '../../config'
  import HTMLStringParser from '../../helpers/HTMLStringParser'
  import CreateQuestion from "../../components/Questions/CreateQuestion/CreateQuestion";
  import TopContributors from "../../components/Questions/TopContributors/TopContributors";
  import ScrollerMixin from '../../mixins/ScrollerMixin'
  import MyQuestions from "../../components/Questions/MyQuestions/MyQuestions";
  import SearchQuestions from "../../components/Questions/SearchQuestions/SearchQuestions.vue";
  import "./Questions.less";
  import HCPMixin from "../../mixins/HCPMixin";
  import ReportingMixin from "../../mixins/ReportingMixin"
  import ReportModal from "../../components/Reporting/Reporting.vue";
  import TitleManager from '../../helpers/TitleManager';
  import MuBadge from "muse-ui/src/badge/badge";
  import formatDate from "../../helpers/FormatDate";
  import userApi from "../../api/User";

  export default {
    components: {
      MuBadge,
      SearchQuestions,
      MyQuestions,
      TopContributors,
      CreateQuestion,
      ReportModal,
    },
    mixins: [ScrollerMixin, ReportingMixin, HCPMixin],
    data() {
      return {
        isSearching: false,
        isLoading: true,
        rightTop: {horizontal: 'right', vertical: 'top'},
        dummyLoaders: [],
        categories: [],
        query: {
          page: 1,
          per_page: 25,
          type: "MOST_RECENT",
        },
        filterTypes: [
          {
            title: this.$t('message.discussionTabRecent'),
            type: "MOST_RECENT"
          },
          {
            title: this.$t('message.discussionTabTrending'),
            type: "MOST_TRENDING",
          },
          {
            title: this.$t('message.discussionTabUseful'),
            type: "MOST_USEFUL"
          },
          {
            title: this.$t('message.discussionTabMyQuestions'),
            type: 'MY_QUESTIONS',
          },
          {
            title: this.$t('message.discussionTabMyAnswers'),
            type: 'MY_ANSWERS',
          },
          {
            title: this.$t('message.discussionTabUnanswered'),
            type: 'UNANSWERED'
          }
        ],
        data: {},
        user: {
          user_id: 0
        },
        userAnswers: 0,
        userQuestions: 0,
      }
    },
    watch: {
      '$route': function () {
        let self = this;
        self.getAmountNumbers();
        self.query.page = parseInt(self.$route.query.page ? self.$route.query.page : 1);
        self.query.type = self.$route.query.type ? self.$route.query.type : 'MOST_RECENT';
        self.query.q = self.$route.query.q ? self.$route.query.q : 'false'
        self.query.category = self.$route.query.category ? self.$route.query.category : null;


        let query = {};

        if (self.$route.query.type === 'CATEGORY') {
          query = {
            page: self.query.page,
            per_page: self.query.per_page,
            type: self.query.type,
            category: self.$route.query.category
          };
        }
        else {
          query = {
            page: self.query.page,
            per_page: self.query.per_page,
            type: self.query.type
          }
        }

        if (self.query.type === 'SEARCH') {
          self.isSearching = true;
          query.q = self.query.q
        }

        if (self.isHcpView && self.query.type != 'SEARCH') {
          self.query.type = 'HCP';
          query.type = self.query.type;
          self.$router.push({
            name: 'QuestionsIndex'
          })
        } else {
          //called
          self.$router.replace({
            query: query
          });
        }

        self.loadData(query);
      },
      'query.category': function () {
        let self = this;


        let query = {
          page: self.query.page,
          per_page: self.query.per_page,
          type: self.query.type,
          q: self.query.q,
          category: self.query.category
        };

        if (self.query.type !== 'CATEGORY') {

          query = {
            page: self.query.page,
            per_page: self.query.per_page,
            type: self.query.type,
            q: self.query.q
          };
        }


        if (self.isHcpView && self.query.type !== 'SEARCH' && self.query.type !== 'CATEGORY') {
          self.query.type = 'HCP';
          query.type = self.query.type;
          self.$router.push({
            name: 'QuestionsIndex'
          })
        } else {
          self.$router.replace({
            query: query
          });
        }
      },
      'query.type': function () {
        let self = this;
        let query = {
          page: self.query.page,
          per_page: self.query.per_page,
          type: self.query.type,
          q: self.query.q,
          category: self.query.category
        };

        if (self.isHcpView && self.query.type != 'SEARCH') {
          self.query.type = 'HCP';
          query.type = self.query.type;
          self.$router.push({
            name: 'QuestionsIndex'
          })
        } else {
          self.$router.replace({
            query: query
          });
        }
      }
    },
    mounted() {
      let self = this;
      self.user = self.$store.state.user.scope;
      self.getAmountNumbers();

      if (self.isHcpView) {
        TitleManager.replaceTitle("Forum");
      }

      self.createDummyLoaders();

      self.$gtag.pageview('/questions');

      if (_.has(self.$route.query, 'page')) {
        self.query.page = parseInt(self.$route.query.page);
      }
      if (_.has(self.$route.query, 'type')) {
        self.query.type = self.$route.query.type || 'MOST_RECENT';
      }

      if (_.has(self.$route.query, 'category')) {
        self.query.category = self.$route.query.category;
      }

      if (_.has(self.$route.query, 'q')) {
        self.query.q = self.$route.query.q;
      }

      if (self.isHcpView) {
        self.query.type = 'HCP';
      }

      self.loadData(self.query);
    },
    methods: {
      getAmountNumbers() {
        let self = this;
        userApi.getUser()
          .then(function(res) {
            self.userQuestions = res.data.stats.userQuestions;
            self.userAnswers = res.data.stats.userAnswers;
          })
      },
      upperCaseFirst(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
      },
      setReported() {
        let self = this,
          currentThread;
        if (self.activeReport.type === 'THREAD_QUESTION') {
          currentThread = self.data.questions.filter((item) => {
            return item.question_id === self.activeReport.type_id;
          })[0];
        }
        currentThread.reported = true;
        self.$forceUpdate();
      },
      goToProfile(url) {
        let self = this;
        self.$router.push({
          name: 'Profile',
          params: {
            profileUrl: url,
          }
        })
      },
      getRandomArbitrary(min, max) {
        return Math.floor(Math.random() * (max - min) + min) + '%'
      },

      setCategory(item) {
        let self = this;
        self.$nextTick(function () {
          self.query.type = 'CATEGORY'
          self.query.category = item.id;
          self.query.page = 1;

          self.$router.replace({query: self.query});
        });
      },
      setFilter(item) {
        let self = this;
        self.$nextTick(function () {
          self.query.type = item.type
          self.query.page = 1;
          self.$router.replace({query: self.query});
        });
      },
      hideQuestion(question, index) {
        let self = this;
        DiscussionApi.hideQuestion(question.question_id)
          .then(function (response) {
            let hidden, hiddenVal = response.data.message;
            hidden = hiddenVal === "Hidden";
            self.$nextTick(function () {
              question.hidden = hidden;
            });
          });
      },
      deleteQuestion(question, index) {
        let self = this;
        const swal = self.$alert;
        self.$alert({
          title: "Are you sure?",
          text: "You are about to delete a question",
          type: "warning",
          showCancelButton: true,
          showLoaderOnConfirm: false,
          confirmButtonColor: "white",
          cancelButtonColor: "white",
          preConfirm: function () {
            return DiscussionApi.deleteQuestion(question.question_id)
          }
        })
          .then(function (response) {
            self.$alert({
              title: "Success!",
              text: "Question was deleted",
              type: "success",
              showCancelButton: false,
              confirmButtonColor: "white"
            });
            self.data.questions.splice(index, 1);
          }.bind(self))
          .catch(self.$alert.noop)
      }
      ,
      createDummyLoaders() {
        let self = this;
        const dummyItems = self.query.per_page;
        for (let i = 0; i < dummyItems; i++) {
          self.dummyLoaders.push({});
        }
      }
      ,
      refresh() {
        let self = this;
        self.query.page = 1;
        self.query.per_page = 10;
        self.query.type = 'MOST_RECENT';
        self.query.category = null;
        self.loadData(self.query);
        self.$router.replace({
          page: 1,
          type: "MOST_RECENT"
        })
      }
      ,
      askQuestion() {
        let self = this;
        if (self.$store.state.status.payment.paid) {
          self.$router.push({
            name: 'Ask a question'
          })
        } else {
          self.$EventBus.$emit('App::triggerPaywall', true);
        }
      }
      ,
      encodeText(string) {
        return HTMLStringParser.encode(string);
      }
      ,
      handlePageChange(page) {
        let self = this;
        if (self.query.type === 'SEARCH') {
          self.$router.replace({
            query: {
              q: self.query.q,
              page: page,
              per_page: self.query.per_page,
              type: self.query.type
            }
          })

        }
        else {


          if (self.query.type === 'CATEGORY') {
            self.$router.replace({
              query: {
                page: page,
                type: self.query.type,
                per_page: self.query.per_page,
                category: self.$route.query.category
              }
            })
          }
          else {
            self.$router.replace({
              query: {
                page: page,
                type: self.query.type
              }
            })
          }


        }
      }
      ,
      loadData(query) {
        let self = this;
        self.isLoading = true;
        if (DiscussionApi.CancelRequests !== null) {
          DiscussionApi.CancelRequests();
        }
        DiscussionApi.getDiscussionQuestions(query)
          .then(function (response) {
            self.data = response.data;
            self.isLoading = false;
            self.isSearching = false;
          })
          .catch(function (error) {
          })
      }
      ,
      goToQuestion(id) {
        let self = this;
        if (self.$store.state.status.payment.paid) {
          self.$router.push({
            path: '/questions/thread/' + id,
            query: {
              page: 1,
              per_page: 10
            }
          });
        } else {
          self.$EventBus.$emit('App::triggerPaywall', true);
        }
      }
      ,
      upperTwoInitials(displayName) {
        if (displayName.indexOf(' ') !== -1) {
          const splitString = displayName.split(' ');
          return splitString[0].charAt(0).toUpperCase() + splitString[1].charAt(0).toUpperCase();
        }
        return displayName.charAt(0).toUpperCase();
      },
      formatDate(date) {
        return formatDate(date)
      }
    }
    ,
    computed: {
      isAuthAdmin() {
        let self = this;
        if (self.$store.state.user.scope) {
          return self.$store.state.user.user_role.role_id === 2;
        }
      }
      ,
      displayMessage() {
        let self = this,
          message = "";
        if (self.data.total_questions === 0) {
          switch (self.query.type) {
            case "MY_ANSWERS":
              message = self.$t('message.discussionMyAnswersEmpty');
              break;
            case "MY_QUESTIONS":
              message = self.$t('message.discussionMyQuestionsEmpty');
              break;
            case "HCP":
              message = self.$t('message.discussionHcpEmpty');
              break;
          }
          return message;
        }
      }
    }
  }
</script>
<style>

  .darkGreenBadge {
    color: white !important;
    background: #3d8517 !important;
  }

  ul.horizontalScroll {
    margin: 0;
    padding: 0;
  }

  @media (max-width: 476px) {
    .askButton {
      font-size: 8px;
    }
  }

  #questions-index .isHidden {
    opacity: 0.5;
  }

  #questions-index .mu-card-title.blueTitle {
    font-size: 16px;
  }

  #questions-index .padding8 {
    padding-top: 8px;
    padding-bottom: 8px;
  }

  #questions-index .alignCenter {
    align-self: center
  }

  #questions-index .mu-item-text {
    max-height: 100% !important;
  }

  .noCursor .mu-item-wrapper {
    cursor: default !important;
  }

  #questions-index .underlineFocus {
    background: #0179d5 !important;
  }

  #questions-index .mu-select-field {
    margin-bottom: -16px !important;
  }

  #questions-index .nav {
    margin-left: -24px;
    margin-right: -24px;
    margin-top: -24px;
  }

  #questions-index .nav .mu-content-block {
    padding-left: 24px;
    padding-right: 24px;
    padding-top: 8px;
    padding-bottom: 12px;
  }

  #questions-index .nav ul {
    margin: 0
  }

  @media (max-width: 480px) {

    #questions-index .horizontalScroll {
      overflow-x: scroll;
    }

    #questions-index .nav {
      margin-left: -16px;
      margin-right: -16px;
      margin-top: -8px;
    }

  }

  #questions-index .nav ul li {
    cursor: pointer;
    color: #0179d5;
    font-size: 16px;
    padding: 12px 16px;
    display: inline-block;
    border-bottom-color: white !important;
    border-bottom: 4px solid;
    margin-top: 4px;
  }

  #questions-index .nav ul li.isActive {
    font-weight: bold;
    border-bottom-color: #0179d5 !important;
  }

  #questions-index .actions {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  #questions-index .label-container {
    display: inline-flex;
    align-items: center;
    margin-right: 16px;
  }

  #questions-index .inline-label {
    margin-left: 4px;
  }

  .mu-menu-item-wrapper.active {
    color: #0179d5 !important;
  }
</style>



// WEBPACK FOOTER //
// QuestionsIndex.vue?c885af82